import dayjs from 'dayjs';

const formatShipByDate = (d) => {
  if (!d) return '—';
  const parsed = dayjs(d);
  return parsed.isValid() ? parsed.format('MM/DD/YYYY') : '—';
};

export default formatShipByDate;
